import React from 'react';

import {MaskStatistics} from "../../api";

import AnalysisBatchHeader from "./AnalysisBatchHeader";
import ImageDetailsIcon from "./ImageDetailsIcon";

import TruncatedText from "../TruncatedText";

interface BatchSummaryItem {
    statistics: MaskStatistics;
    included: boolean;
    name: string;
}

interface BatchSummaryProps {
    batchId: string;
    items: BatchSummaryItem[];
    onSelect: (i: number, batchId: string) => void;
    selectedItem: number;
}

class AnalysisBatchSummary extends React.Component<BatchSummaryProps> {
    public static defaultProps = {
        onSelect: () => {return;}
    };

    public render() {
        return (<table className="results-table">
            <thead>
            <AnalysisBatchHeader itemCount={this.props.items.length} includedStatistics={
                this.props.items.filter(item => item.included).map(item => item.statistics)
            }/>
            </thead>

            <tbody>
            {
                this.props.items.map((item, i) => <tr key={i} className={i === this.props.selectedItem ? "active" : ""}>
                    <td onClick={() => this.props.onSelect(i, this.props.batchId)}>
                        <TruncatedText text={item.name} icon={<ImageDetailsIcon included={item.included} />}/>
                    </td>
                    <td>{item.statistics.isletCount}</td>
                    <td>{item.statistics.ieTable.toFixed(2)}</td>
                    <td>{item.statistics.ieEllipse.toFixed(2)}</td>
                </tr>)
            }
            </tbody>
        </table>);
    }
}


export default AnalysisBatchSummary;
